module.exports = __webpack_public_path__ + "fonts/proximanova-light-webfont.cc707cc8.eot";